import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lni-music",
  "use": "lni-music-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64 64\" id=\"lni-music\">\r\n<path d=\"M60.2,2.2c-0.5-0.4-1.2-0.6-1.9-0.4L22.2,9.7c-1,0.2-1.8,1.1-1.8,2.2v30.6c-1.8-1.3-4.1-2.1-6.5-2.1c-6.1,0-11,4.9-11,11\r\n\ts4.9,11,11,11s11-4.9,11-11V29.1l31.7-6.9v14.1c-1.8-1.3-4.1-2.1-6.5-2.1c-6.1,0-11,4.9-11,11s4.9,11,11,11s11-4.9,11-11V4\r\n\tC61.1,3.3,60.8,2.7,60.2,2.2z M13.9,57.8c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5S17.5,57.8,13.9,57.8z M24.9,13.7\r\n\tl31.7-6.9v10.8l-31.7,6.9V13.7z M50.1,51.6c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5S53.7,51.6,50.1,51.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/lni/music.svg
// module id = a9wF
// module chunks = 19